// extracted by mini-css-extract-plugin
module.exports = {"header":"e_Ko","gallery":"e_Lo","label":"e_Mo"};